import React from 'react';
import {
  StyledBreadcrumbContainer,
  StyledBreadcrumbText,
  StyledLink,
  StyledSlash,
} from './styled';

export interface BreadcrumbsProps {
  steps: { text: string; url?: string }[];
}

export const Breadcrumbs: React.FC<BreadcrumbsProps> = ({ steps }) => (
  <StyledBreadcrumbContainer>
    {steps.map((step, index) => (
      // eslint-disable-next-line react/no-array-index-key
      <StyledBreadcrumbText key={`${step?.text?.replace(' ', '-')}-${index}`}>
        {index !== steps.length - 1 && step.url ? (
          <StyledLink to={step.url}>{step.text}</StyledLink>
        ) : (
          step.text
        )}
        <StyledSlash>{index !== steps.length - 1 && '/'}</StyledSlash>
      </StyledBreadcrumbText>
    ))}
  </StyledBreadcrumbContainer>
);
